var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningFill0IconV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.938 17.083a.768.768 0 01-.698-.395.728.728 0 01-.011-.792L9.312 3.688c.167-.264.396-.396.688-.396.292 0 .521.132.688.396l7.083 12.208a.727.727 0 01-.011.792.768.768 0 01-.698.395H2.938zm7.083-8.562a.641.641 0 00-.469.198.641.641 0 00-.198.469v2.75c0 .167.066.32.198.458a.626.626 0 00.469.208c.18 0 .337-.07.469-.208a.651.651 0 00.198-.458v-2.75a.641.641 0 00-.198-.469.641.641 0 00-.469-.198zm0 6.312c.194 0 .36-.07.5-.208a.682.682 0 00.208-.5.682.682 0 00-.208-.5.684.684 0 00-.5-.208.682.682 0 00-.5.208.68.68 0 00-.209.5c0 .195.07.361.209.5a.682.682 0 00.5.208zm-6.167.917h12.292L10 5.167 3.854 15.75z",
    fill: "#fff"
  })));
}

export default SvgWarningFill0IconV2;